import { ssv2314CadtrFlagWsResource } from '@/shared/api.resource';

import {
  FETCH_SSV2314_CADTR_FLAG_WS_BY_ID,
  FETCH_PAGINATED_SSV2314_CADTR_FLAG_WSS,
  UPDATE_SSV2314_CADTR_FLAG_WS,
  CREATE_SSV2314_CADTR_FLAG_WS,
  DELETE_SSV2314_CADTR_FLAG_WS,
  RESET_SSV2314_CADTR_FLAG_WS_FILTERS,
  RESET_SSV2314_CADTR_FLAG_WS,
  RESET_SSV2314_CADTR_FLAG_WSS_LIST,
} from './actions.type';

import {
  SET_SSV2314_CADTR_FLAG_WS,
  SET_PAGINATED_SSV2314_CADTR_FLAG_WSS,
  RESET_STATE_SSV2314_CADTR_FLAG_WS_FILTERS,
  RESET_STATE_SSV2314_CADTR_FLAG_WS,
  RESET_STATE_SSV2314_CADTR_FLAG_WS_LIST,
} from './mutations.type';

const initialState = {
  ssv2314CadtrFlagWsFilters: {},
  ssv2314CadtrFlagWs: {},
  paginatedSsv2314CadtrFlagWss: {
    content: [],
    totalElements: 0,
    size: 0
  }
};

export const state = JSON.parse(JSON.stringify(initialState));

export const actions = {
  async [FETCH_SSV2314_CADTR_FLAG_WS_BY_ID](context, id) {
    const { data } = await ssv2314CadtrFlagWsResource.get({ id: id });
    context.commit(SET_SSV2314_CADTR_FLAG_WS, data);
    return data;
  },
  async [FETCH_PAGINATED_SSV2314_CADTR_FLAG_WSS](context, params) {
    const { data } = await ssv2314CadtrFlagWsResource.query(params);
    context.commit(SET_PAGINATED_SSV2314_CADTR_FLAG_WSS, data);
    return data;
  },
  async [CREATE_SSV2314_CADTR_FLAG_WS](context) {
    const { data } = await ssv2314CadtrFlagWsResource.save(state.ssv2314CadtrFlagWs);
    context.commit(SET_SSV2314_CADTR_FLAG_WS, data);
    return data;
  },
  async [UPDATE_SSV2314_CADTR_FLAG_WS](context, id) {
    const { data } = await ssv2314CadtrFlagWsResource.update({ id: id }, state.ssv2314CadtrFlagWs);
    context.commit(SET_SSV2314_CADTR_FLAG_WS, data);
    return data;
  },
  [DELETE_SSV2314_CADTR_FLAG_WS](context, id) {
    return ssv2314CadtrFlagWsResource.delete({ id: id });
  },
  [RESET_SSV2314_CADTR_FLAG_WS_FILTERS]({ commit }) {
    commit(RESET_STATE_SSV2314_CADTR_FLAG_WS_FILTERS);
  },
  [RESET_SSV2314_CADTR_FLAG_WS]({ commit }) {
    commit(RESET_STATE_SSV2314_CADTR_FLAG_WS);
  },
  [RESET_SSV2314_CADTR_FLAG_WSS_LIST]({ commit }) {
    commit(RESET_STATE_SSV2314_CADTR_FLAG_WS_LIST);
  }
};

export const mutations = {
  [SET_SSV2314_CADTR_FLAG_WS](state, ssv2314CadtrFlagWs) {
    state.ssv2314CadtrFlagWs = ssv2314CadtrFlagWs;
  },
  [SET_PAGINATED_SSV2314_CADTR_FLAG_WSS](state, paginatedSsv2314CadtrFlagWss) {
    state.paginatedSsv2314CadtrFlagWss = paginatedSsv2314CadtrFlagWss;
  },
  [RESET_STATE_SSV2314_CADTR_FLAG_WS](state) {
    state.ssv2314CadtrFlagWs = JSON.parse(JSON.stringify(initialState.ssv2314CadtrFlagWs));
  },
  [RESET_STATE_SSV2314_CADTR_FLAG_WS_FILTERS](state) {
    state.ssv2314CadtrFlagWsFilters = JSON.parse(JSON.stringify(initialState.ssv2314CadtrFlagWsFilters));
  },
  [RESET_STATE_SSV2314_CADTR_FLAG_WS_LIST](state) {
    state.paginatedssv2314CadtrFlagWss = JSON.parse(JSON.stringify(initialState.paginatedSsv2314CadtrFlagWss));
  }
};

export const getters = {
  ssv2314CadtrFlagWs(state) {
    return state.ssv2314CadtrFlagWs;
  },
  ssv2314CadtrFlagWsFilters(state) {
    return state.ssv2314CadtrFlagWsFilters;
  },
  paginatedSsv2314CadtrFlagWss(state) {
    return state.paginatedSsv2314CadtrFlagWss;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}